import { render, staticRenderFns } from "./GetVerifyCode.vue?vue&type=template&id=90f6ae08"
import script from "./GetVerifyCode.vue?vue&type=script&lang=js"
export * from "./GetVerifyCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports